import React from 'react';
import { useNavigate } from 'react-router-dom';
import { User, BarChart3, Moon, Sun, LogOut, Users, Image, Shield } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const SidebarMenu = ({ 
  theme, 
  currentThemeName, 
  isAdmin, 
  isToggling, 
  toggleTheme, 
  handleLogout 
}) => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div 
      style={{
        position: 'fixed',
        top: '50%',
        right: '32px',
        transform: 'translateY(-50%)',
        background: theme.modalBg,
        borderRadius: '12px',
        border: `1px solid ${theme.primaryBorder}`,
        boxShadow: `0 10px 25px ${theme.primaryShadow}`,
        minWidth: '220px',
        zIndex: 1000,
        overflow: 'hidden'
      }}
    >
      <button
        onClick={(e) => {
          e.stopPropagation();
          console.log('Profile clicked');
          navigate('/profile');
        }}
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          padding: '12px 16px',
          background: 'transparent',
          border: 'none',
          color: theme.primaryText,
          cursor: 'pointer',
          transition: 'background 0.2s ease',
          fontSize: '14px',
          fontWeight: '500',
          textAlign: 'left',
          justifyContent: 'flex-start'
        }}
        onMouseEnter={e => {
          e.currentTarget.style.background = theme.tertiaryBg || '#f1f5f9';
        }}
        onMouseLeave={e => {
          e.currentTarget.style.background = 'transparent';
        }}
      >
        <User size={16} />
{t('common.profile')}
      </button>

      {isAdmin && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            navigate('/admin');
          }}
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '12px 16px',
            background: 'transparent',
            border: 'none',
            color: theme.primaryText,
            cursor: 'pointer',
            transition: 'background 0.2s ease',
            fontSize: '14px',
            fontWeight: '500',
            textAlign: 'left',
            justifyContent: 'flex-start'
          }}
          onMouseEnter={e => {
            e.currentTarget.style.background = theme.tertiaryBg || '#f1f5f9';
          }}
          onMouseLeave={e => {
            e.currentTarget.style.background = 'transparent';
          }}
        >
          <Shield size={16} />
          Admin
        </button>
      )}

      {isAdmin && (
        <>
          <button
            onClick={(e) => {
              e.stopPropagation();
              window.location.href = '/analytics';
            }}
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '12px 16px',
              background: theme.tertiaryBg,
              border: 'none',
              color: theme.primaryText,
              cursor: 'pointer',
              transition: 'background 0.2s ease',
              fontSize: '14px',
              fontWeight: '500',
              textAlign: 'left',
              justifyContent: 'flex-start'
            }}
            onMouseEnter={e => {
              e.currentTarget.style.background = theme.tertiaryBg || '#f1f5f9';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.background = theme.tertiaryBg || '#f1f5f9';
            }}
          >
            <BarChart3 size={16} />
{t('common.businessAnalytics')}
          </button>

          <button
            onClick={(e) => {
              e.stopPropagation();
              navigate('/admin/content-edit');
            }}
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '12px 16px',
              background: 'transparent',
              border: 'none',
              color: theme.primaryText,
              cursor: 'pointer',
              transition: 'background 0.2s ease',
              fontSize: '14px',
              fontWeight: '500',
              textAlign: 'left',
              justifyContent: 'flex-start'
            }}
            onMouseEnter={e => {
              e.currentTarget.style.background = theme.tertiaryBg || '#f1f5f9';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.background = 'transparent';
            }}
          >
            <Image size={16} />
            {t('contentEdit.contentEditor')}
          </button>

          <button
            onClick={(e) => {
              e.stopPropagation();
              navigate('/userlist');
            }}
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '12px 16px',
              background: 'transparent',
              border: 'none',
              color: theme.primaryText,
              cursor: 'pointer',
              transition: 'background 0.2s ease',
              fontSize: '14px',
              fontWeight: '500',
              textAlign: 'left',
              justifyContent: 'flex-start'
            }}
            onMouseEnter={e => {
              e.currentTarget.style.background = theme.tertiaryBg || '#f1f5f9';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.background = theme.tertiaryBg || '#f1f5f9';
            }}
          >
            <Users size={16} />
{t('common.userManagement')}
          </button>
        </>
      )}

      <button
        onClick={(e) => {
          e.stopPropagation();
          if (isToggling) return;
          toggleTheme();
        }}
        disabled={isToggling}
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          padding: '12px 16px',
          background: 'transparent',
          border: 'none',
          color: theme.primaryText,
          cursor: isToggling ? 'not-allowed' : 'pointer',
          transition: 'background 0.2s ease',
          fontSize: '14px',
          fontWeight: '500',
          opacity: isToggling ? 0.6 : 1,
          textAlign: 'left',
          justifyContent: 'flex-start'
        }}
        onMouseEnter={e => {
          if (!isToggling) {
            e.currentTarget.style.background = theme.tertiaryBg || '#f1f5f9';
          }
        }}
        onMouseLeave={e => {
          if (!isToggling) {
            e.currentTarget.style.background = 'transparent';
          }
        }}
      >
        {isToggling ? (
          <>
            <div style={{ width: '16px', height: '16px', border: '2px solid transparent', borderTop: '2px solid currentColor', borderRadius: '50%', animation: 'spin 1s linear infinite' }}></div>
            Switching...
          </>
        ) : (
          <>
            {currentThemeName === 'dark' ? <Moon size={16} /> : currentThemeName === 'beige' ? <Sun size={16} /> : <Moon size={16} />}
{t('common.changeTheme')}
          </>
        )}
      </button>
      
      <button
        onClick={(e) => {
          e.stopPropagation();
          handleLogout();
        }}
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          padding: '12px 16px',
          background: 'transparent',
          border: 'none',
          color: '#ef4444',
          cursor: 'pointer',
          transition: 'background 0.2s ease',
          fontSize: '14px',
          fontWeight: '500',
          textAlign: 'left',
          justifyContent: 'flex-start'
        }}
        onMouseEnter={e => {
          e.currentTarget.style.background = 'rgba(239, 68, 68, 0.1)';
        }}
        onMouseLeave={e => {
          e.currentTarget.style.background = 'transparent';
        }}
      >
        <LogOut size={16} />
{t('common.logout')}
      </button>
    </div>
  );
};

export default SidebarMenu;
